// client/src/utils/invoiceCategories.ts
//
// MIRRORED FILE — twin of src/utils/invoiceCategories.js. Change one, change both;
// src/__tests__/mirroredUtilParity.test.js compares them.
//
// The one list of header categories a client invoice or a credit note carries
// (BUSINESS_RULES#invoice-header-categories, D157.17): the Details tab and the credit-note
// page both read it.

export const CUSTOMS_CATEGORY = 'customs';

export const INVOICE_CATEGORIES: ReadonlyArray<{ value: string; label: string }> = Object.freeze([
  { value: 'provision', label: 'Provision' },
  { value: 'cabin', label: 'Cabin' },
  { value: 'bonded', label: 'Bonded' },
  { value: 'other', label: 'Other' },
  { value: CUSTOMS_CATEGORY, label: 'Customs' },
]);

export type InvoiceCategory = 'provision' | 'cabin' | 'bonded' | 'other' | 'customs' | '';

// The category <select>: a blank first option, then the list.
export const CATEGORY_SELECT_OPTIONS: ReadonlyArray<{ value: string; label: string }> = Object.freeze([
  { value: '', label: 'Select category' },
  ...INVOICE_CATEGORIES,
]);
